import { Pipe, PipeTransform } from '@angular/core';

const SOFT_HYPHEN = '­';

// German compounds usually join with a linking "s" after these suffixes (Tätigkeits|nachweise, Abwesenheits|anfragen).
const COMPOUND_JOINT = /(heit|keit|ung|schaft|tät|ion)s(?=\p{L}{3,})/giu;

/**
 * Inserts soft hyphens at likely German compound-word boundaries. Combined with CSS `hyphens: auto`,
 * the browser then prefers these boundaries over dictionary syllable breaks (TÄTIGKEITS- / NACHWEISE
 * instead of TÄTIGKEITSNACH- / WEISE). The hyphen is only rendered when the line actually breaks there.
 */
@Pipe({ name: 'baseSoftHyphenate' })
export class BaseSoftHyphenatePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return value ? value.replace(COMPOUND_JOINT, `$&${SOFT_HYPHEN}`) : '';
  }
}
